import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MaintenanceModeBannerComponent } from 'src/app/core/components/maintenance-mode-banner/maintenance-mode-banner.component';
import { MaintenanceModeService } from 'src/app/core/services/http/maintenanceMode.service';

@Component({
  selector: 'app-maintenance-mode-page',
  standalone: true,
  imports: [MaintenanceModeBannerComponent, NgIf],
  templateUrl: './maintenance-mode-page.component.html',
  styleUrl: './maintenance-mode-page.component.scss'
})
export class MaintenanceModePageComponent {
  constructor(public maintenanceModeService: MaintenanceModeService) {}
}
